module.exports = "data:image/gif;base64,R0lGODlhGwAbAMQVAP///4Wz84Cx9NLi+Ji/9LTO9Ym286nI9fD1/P7+/rzV93mt88ba9+Lr+vz9/urx/Pn6/dvo++jv+vb6/vP3/f///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAABUALAAAAAAbABsAAAWpYCWOpPhUZ6muZlUQAVEhbN0QQh4EwiLUq0LAEDsojpWDDygaCAwGwiFYWDBjUeahwHpgp0xggQgOsyI7rhn4XIsFBIl7dRMw5iSaiIcnRaYRBgIDfSNgOISFA2AFAmp9DGARCzKFjxU7d30FKRUMcH0Kl5gGo0xOKp8GmmYBZSQHQ4lADVksMAYoXZiVNY1Pd3o0nwumKwMwC8o7ygIHs2YMChVH1YV9IQA7"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign_have.gif
// module id = KCsx
// module chunks = 121